$(document).ready(function(){

	var fancyboxSettings = {};

	$('[data-fancybox]').fancybox(fancyboxSettings);

});
